import { Getter } from 'vuex'
import { RootState } from '@/store/types'
import { ArticleState } from '../types'

const articleName: Getter<ArticleState, RootState> = (state) => {
  return state.activeArticle?.name || ''
}

export default articleName
